import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { company, images } from "@/data/company";

const points = [
  "Full-stack engineering & design under one roof",
  "Marketing that is measured against revenue",
  "Transparent pricing and fixed timelines",
  "Long-term partnership, not one-off projects",
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#0d1526] border-y border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative"
        >
          <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-[#22d3ee]" />
          <img
            src={images.about}
            alt="NetForge team collaborating"
            className="w-full h-[480px] object-cover rounded-sm"
          />
          <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-[#22d3ee]" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-xs uppercase tracking-[0.2em] text-[#22d3ee] font-bold mb-4">
            Who we are
          </p>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white leading-tight">
            A studio built for the next generation of business.
          </h2>
          <p className="mt-6 text-slate-400 leading-relaxed">
            {company.name} unites elite engineers, designers and marketers into
            one focused team. We partner with founders and enterprises to design,
            build and scale digital products and the campaigns that drive them.
          </p>

          <ul className="mt-8 space-y-4">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <span className="mt-0.5 w-5 h-5 flex items-center justify-center bg-[#22d3ee] rounded-sm shrink-0">
                  <Check size={13} className="text-[#0a0f1e]" />
                </span>
                <span className="text-slate-200">{p}</span>
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};
